import type { IAvailability } from "@app/availability/types";

import { matchShortId } from "../ids/generateIds";
import { getRateByShortId } from "./getRateByShortId";

export const getBookingRoomRate = (params: string, availability: IAvailability[]) => {
    if (!params || !availability.length) {
        return [];
    }

    const q = new URLSearchParams(params);
    const rateRoomIds: string[][] = [];
    // Process the new semicolon-separated br parameter
    const brValue = q.get("br");
    if (brValue) {
        const bookingsData = brValue.split(";");
        bookingsData.forEach((value, brIndex) => {
            const [bookings] = value.split("|");
            const props = (bookings || "").split(",");
            const type = props[1] === "_" ? "room" : "package";
            const foundPackage = (availability[brIndex]?.packages || []).find((p) => matchShortId(p.id, props[1])) || null;
            const foundRoom = (availability[brIndex]?.rooms || []).find((r) => matchShortId(props[2], r.id)) || null;
            const foundRate = getRateByShortId(type === "room" ? foundRoom : foundPackage, props[3]) || null;

            rateRoomIds.push(foundRoom && foundRate ? [foundRoom.id, foundRate.id] : []);
        });
    }

    return rateRoomIds;
};
